export default __webpack_public_path__ + "9acaf533b2618730a01d6bff6b6d20d7.ttf";